import _get from 'lodash/get';
import { Value } from '@lib/interfaces/form';

export default function getPhoneNumberValueFromQueryData(data?: object) {
  const phoneNumber = _get(data, 'phoneNumber') as string | null | undefined;
  if (!phoneNumber) {
    return { country: '', countryCode: '', phone: '', number: '' } as Value;
  }
  const phone = phoneNumber.replace(/^\+/, '');
  return { country: '', countryCode: '', phone, number: '' } as Value;
}
